import { BehaviorSubject } from 'rxjs';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AdminValidationService {
  state = new BehaviorSubject<{
    awards: { editMode: boolean, lastIndex: number },
    challenges: { editMode: boolean, lastIndex: number },
    games: { editMode: boolean, lastIndex: number }
  }>({
    awards: { editMode: true, lastIndex: 0 },
    challenges: { editMode: true, lastIndex: 0 },
    games: { editMode: true, lastIndex: 0 }
  });

  state$ = this.state.asObservable();

  // Flag to indicate if the loading/saving process is being executed.
  private _isLoadingSavingProcess = new BehaviorSubject<boolean>(false);
  isLoadingSavingProcess$ = this._isLoadingSavingProcess.asObservable();

  get isLoadingSavingProcess(): boolean {
    return this._isLoadingSavingProcess.value;
  }

  set isLoadingSavingProcess(value: boolean) {
    this._isLoadingSavingProcess.next(value);
  }

  constructor(
    private dialogService: CvCustomDialogService,
    private cvLocalizationService: CVLocalizationService,
  ) { }

  showUnsavedChangesDialog(onSuccessCallback: () => void) {
    const message = this.cvLocalizationService.getCachedText("Common", "Changes_Lost", "All changes will be lost.");
    this.dialogService.showDialog(
      this.cvLocalizationService.getCachedText("Common", "Leave", "Leave?"),
      `<div class="modal-body-text"> ${message} </div>`,
      11,
      this.cvLocalizationService.getCachedText("Common", "Stay_Btn", "Stay"),
      this.cvLocalizationService.getCachedText("Common", "Leave_Btn", "Leave"),
      true,
      () => {onSuccessCallback();

      },
      () => { },
      '',
      true,
      {
        keyboard: false,
        backdrop: 'static',
        centered: true,
        windowClass: 'cxone-validation-modal-admin-tabs-container'
      }
    );
  }
}